import { render } from "./WCFooter.vue?vue&type=template&id=fd390850&scoped=true"
import script from "./WCFooter.vue?vue&type=script&lang=js"
export * from "./WCFooter.vue?vue&type=script&lang=js"

import "./WCFooter.vue?vue&type=style&index=0&id=fd390850&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd390850"]])

export default __exports__